import { useState } from "react";
import { useSelector } from "react-redux";
import { saveNewsLetter } from "../../redux/slices/newsLetter/newsLetterSlice";
import { dispatch } from "../../redux/store";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const { selectedBusinessLocation } = useSelector(
    (state: any) => state.businessLocation
  );
  console.log("businessLocation", selectedBusinessLocation);

  const handleSubscribe = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setError("Please enter a valid email address.");
      return;
    }
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    // const userId = auth?.userId;
    const businessLocationId = selectedBusinessLocation?.id;

    if (!businessLocationId) {
      setError("business location information is missing.");
      return;
    }
    dispatch(saveNewsLetter(email));
    setEmail("");
  };

  return (
    <div className="bg-[#E6E6E6] py-8 px-4 md:px-16 w-full">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        {/* Text Section */}
        <div className="mb-4 md:mb-0">
          <h2 className="text-[16px] md:text-[18px] font-semibold text-[#1A1A1A]">
            Subscribe our Newsletter
          </h2>
          <p className="text-[14px] text-[#666666] mt-2">
            Pellentesque eu nibh eget mauris congue mattis mattis nec tellus.
            Phasellus imperdiet elit eu magna.
          </p>
        </div>

        {/* Input and Button Section */}
        <div className="flex w-full">
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full py-2 px-4 border border-[#E5E5E5] rounded-l-full focus:outline-none"
          />
          <button
            onClick={handleSubscribe}
            className="bg-[#00B207] text-white px-6 py-2 rounded-r-full hover:bg-[#00A206] transition duration-300"
          >
            <div className="font-poppins font-semibold text-[16px] leading-[20px]">
              Subscribe
            </div>
          </button>
        </div>

        {error && <p className="mt-4 text-red-500 font-semibold">{error}</p>}
      </div>
    </div>
  );
};

export default Newsletter;
